import React from 'react'

type Props = {
    className?  : string

    size        : string,
    message     : string,
}

export default class UILoading extends React.Component<Props> {

    static defaultProps = {
        size    : "normal",
        message : "Loading ..."
    }

    render() {
        switch (this.props.size) {
            default:
                return (
                    <div className={Classes("gd-loading", this.props.className)}>
                        <img src={gdConfig.assetsPath + "/skin/common/loader/app-loading.gif?" + gdConfig.build} width={40}/>
                        {!!this.props.message && <p>{this.props.message}</p>}
                    </div>
                )
        }
    }
}